import { isProd, isTest } from '../../helpers/environment';

export const salesforceConfigs = {
  dev: {
    // accessible via *.vercel.app (pre-PR)
    orgId: '00Dct000003qf29',
    deploymentName: 'Quote_Flow_Vercel',
    baseUrl: 'https://coterie--test.sandbox.my.site.com/ESWQuoteFlowVercel1769809252786',
    bootstrapUrl:
      'https://coterie--test.sandbox.my.site.com/ESWQuoteFlowVercel1769809252786/assets/js/bootstrap.min.js',
    scrt2URL: 'https://coterie--test.sandbox.my.salesforce-scrt.com',
    storageDomain: 'vercel.app',
  },
  test: {
    // accessible via *.coterieinsurancetest.com
    orgId: '00Dct000003qf29',
    deploymentName: 'Quote_Flow',
    baseUrl: 'https://coterie--test.sandbox.my.site.com/ESWQuoteFlow1769800382338',
    bootstrapUrl: 'https://coterie--test.sandbox.my.site.com/ESWQuoteFlow1769800382338/assets/js/bootstrap.min.js',
    scrt2URL: 'https://coterie--test.sandbox.my.salesforce-scrt.com',
    storageDomain: 'quote.coterieinsurancetest.com',
  },
  production: {
    // accessible via *.coterieinsurance.com
    orgId: '00D5c000000leJG',
    deploymentName: 'Quote_Flow',
    baseUrl: 'https://coterie.my.site.com/ESWQuoteFlow1754749770069',
    bootstrapUrl: 'https://coterie.my.site.com/ESWQuoteFlow1754749770069/assets/js/bootstrap.min.js',
    scrt2URL: 'https://coterie.my.salesforce-scrt.com',
    storageDomain: 'quote.coterieinsurance.com',
  },
};

export const getSalesforceEnv = () => {
  if (isProd()) return 'production';
  if (isTest()) return 'test';
  return 'dev';
};

export type SalesforceEnv = keyof typeof salesforceConfigs;
